/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CarveOutSource = {
    Auto: 'auto',
    MedsTable: 'meds_table',
    Manual: 'manual',
} as const;
export type CarveOutSource = typeof CarveOutSource[keyof typeof CarveOutSource];


export function instanceOfCarveOutSource(value: any): boolean {
    for (const key in CarveOutSource) {
        if (Object.prototype.hasOwnProperty.call(CarveOutSource, key)) {
            if (CarveOutSource[key as keyof typeof CarveOutSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutSourceFromJSON(json: any): CarveOutSource {
    return CarveOutSourceFromJSONTyped(json, false);
}

export function CarveOutSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutSource {
    return json as CarveOutSource;
}

export function CarveOutSourceToJSON(value?: CarveOutSource | null): any {
    return value as any;
}

export function CarveOutSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutSource {
    return value as CarveOutSource;
}

